module.exports = __webpack_public_path__ + "img/cover-product-de-hair.0233eb75.jpg";